import { IMapLibrePolygonsStyle } from "./maplibre-polygons-layer.models";

/**
 * Defaults are the areas map's Leaflet values (`area-polygons-map.constants.ts`), since that is the
 * richest consumer — the stations map and the polygon viewer override what differs.
 */
export const MAPLIBRE_POLYGONS_DEFAULT_STYLE: IMapLibrePolygonsStyle = {
  fillOpacity: 0.3,
  weight: 2,
  hoverFillOpacity: 0.55,
  hoverWeight: 3,
  dimmedFillOpacity: 0.15,
  dimmedStrokeOpacity: 0.5,
  dimmedWeight: 1,
};

/** Full opacity for a polygon's outline; only dimmed polygons fade their stroke. */
export const MAPLIBRE_POLYGON_STROKE_OPACITY = 1;

/**
 * Class on the hover tooltip, so the shared host can give it the dark pill the areas map drew rather
 * than the white card every other popup gets.
 */
export const MAPLIBRE_POLYGON_TOOLTIP_CLASS = "maplibre-polygon-tooltip";

/** The pill's near-black ground, carried over from the Leaflet tooltip. */
export const MAPLIBRE_POLYGON_TOOLTIP_BACKGROUND = "rgba(33, 37, 41, 0.92)";

/** Gap (px) between the cursor and the polygon's hover tooltip. */
export const MAPLIBRE_POLYGON_TOOLTIP_OFFSET_PX = 12;

/**
 * Stand-in "hovered id" for when nothing is hovered. Polygon ids are entity ids (positive), so a negative
 * sentinel can never match a real feature and the paint expression falls through to its resting branch.
 */
export const MAPLIBRE_POLYGONS_HOVER_NO_MATCH_ID = -1;
